/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const tableSchema = z
	.object({
		id: z.uuid(),
		seating_capacity: z.int().min(0).max(2147483647).optional(),
		number: z.int().min(0).max(2147483647),
		branch: z.uuid().describe("ID отделения стола"),
		external_link: z.string().max(63).nullish(),
		tips_link: z.url().max(200).nullish(),
	})
	.describe(
		"Сериалиазатор стола без полей order и is_free.\nТак как информация по этим полям требует сходить в iiko и сложной логики,\nто при получении списка столов это излишняя логика, которой не пользуется фронт.\nПоэтому для получения списка столов и стола в существующем заказе используется этот сериализатор,\nа для получения информации по конкретному столу - TableOrderSerializer.",
	);
